import { useSearchParams } from 'next/navigation';

import { CompanyProfile } from 'models';
import { CryptoHelpers } from 'helpers/CryptoHelpers';

import { useCurrentProfile } from 'components/company-profile/hooks/use-current-profile';

const useProfilePreview = (company?: CompanyProfile) => {
    const currentCompanyProfile = useCurrentProfile();
    const companyToCheck = company ?? currentCompanyProfile;

    const search = useSearchParams();
    const previewSecret = search?.get('preview') || '';

    return {
        previewSecret: previewSecret,
        previewSecretIsValid: !!(
            companyToCheck &&
            previewSecret &&
            CryptoHelpers.unsafeSimpleHash(companyToCheck.slug) === previewSecret
        ),
    };
};

export { useProfilePreview };
